import React from 'react'
import PropTypes from 'prop-types'
import { Button } from '../mui/Core/index'
import { useTheme } from '../mui/Styles/index'

/* This is a custom button component,
   styled to appear as a hyperlink */
export function LinkButton({ linkText, handleLinkClick, fontSize }) {
  const theme = useTheme()

  const linkButtonStyle = {
    pr: 0,
    pl: 0,
    textDecoration: 'underline',
    cursor: 'pointer',
    color: theme.palette.secondary.main,
    minWidth: '50px',
    justifyContent: 'flex-start',
    '&.MuiButtonBase-root:hover': {
      backgroundColor: 'transparent',
      textDecoration: 'underline',
    },
  }

  const textStyle = {
    fontSize: fontSize || '14px',
    fontFamily: 'AtlasGroteskRegular',
    letterSpacing: 'normal',
  }

  return (
    <Button sx={linkButtonStyle} disableRipple onClick={handleLinkClick}>
      <span style={textStyle}>{linkText}</span>
    </Button>
  )
}

LinkButton.propTypes = {
  linkText: PropTypes.string.isRequired,
  handleLinkClick: PropTypes.func.isRequired,
  fontSize: PropTypes.string,
}

export default LinkButton
